module.exports = __webpack_public_path__ + "img/pushdownWithOutstream.67321128.gif";